import React, { Component } from 'react';
import { Provider } from 'mobx-react';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
import DynamicSatelliteLoadErrorModal from '../components/dialogs/DynamicSatelliteLoadErrorModal';
import RouterScrollToTop from '../components/RouterScrollToTop';
import LandscapeOrientationPrompt from '../components/LandscapeOrientationPrompt';
import './DocReaderLaunch';
import './FileViewerLaunch';
import './PlayerLaunch';

import '../css/App.less';
import '../css/print/App.less';

import accessManager from '../managers/AccessManager';
import accommodationsManager from '../managers/AccommodationsManager';
import adminClassroomManager from '../managers/AdminClassroomManager';
import adminUsersManager from '../managers/AdminUsersManager';
import appManager from '../managers/AppManager';
import assessmentManager from '../managers/AssessmentManager';
import assignmentManager from '../managers/AssignmentManager';
import bandwidthManager from '../managers/BandwidthManager';
import basicIframeModalLauncherManager from '../managers/BasicIframeModalLauncherManager';
import classroomManager from '../managers/ClassroomManager';
import classroomRosterManager from '../managers/ClassroomRosterManager';
import contentItemManager from '../managers/ContentItemManager';
import contentManager from '../managers/ContentManager';
import contextHelpManager from '../managers/ContextHelpManager';
import courseDeliveryManager from '../managers/CourseDeliveryManager';
import courseManager from '../managers/CourseManager';
import courseResourceFilterManager from '../managers/CourseResourceFilterManager';
import curriculumMapManager from '../managers/CurriculumMapManager';
import dialogManager from '../managers/DialogManager';
import docReaderManager from '../managers/DocReaderManager';
import dynamicSatelliteManager from '../managers/DynamicSatelliteManager';
import engagementManager from '../managers/EngagementManager';
import exportManager from '../managers/ExportManager';
import filteredHeaderTableManager from '../managers/FilteredHeaderTableManager';
import googleAnalyticsManager from '../managers/GoogleAnalyticsManager';
import googleClassroomManager from '../managers/GoogleClassroomManager';
import gradebookManager from '../managers/GradebookManager';
import groupsManager from '../managers/GroupsManager';
import guidedTourManager from '../managers/GuidedTourManager';
import itemBankManager from '../managers/ItemBankManager';
import learnosityAuthorManager from '../managers/LearnosityAuthorManager';
import learnosityDataManager from '../managers/LearnosityDataManager';
import learnosityItemsManager from '../managers/LearnosityItemsManager';
import libraryManager from '../managers/LibraryManager';
import loginManager from '../managers/LoginManager';
import ltiManager from '../managers/LtiManager';
import navigationManager from '../managers/NavigationManager';
import notificationManager from '../managers/NotificationManager';
import productManager from '../managers/ProductManager';
import reportContextManager from '../managers/reports/ReportContextManager';
import reportCourseManager from '../managers/reports/ReportCourseManager';
import reportIdentityManager from '../managers/reports/ReportIdentityManager';
import reportOverrideManager from '../managers/reports/ReportOverrideManager';
import reportScoreManager from '../managers/reports/ReportScoreManager';
import reportStandardsClassroomDetailStudentsManager from '../managers/reports/ReportStandardsClassroomDetailStudentsManager';
import reportStandardsManager from '../managers/reports/ReportStandardsManager';
import reportTableManager from '../managers/reports/ReportTableManager';
import reportTypeManager from '../managers/reports/ReportTypeManager';
import reportUsageManager from '../managers/reports/ReportUsageManager';
import resourceBankShopManager from '../managers/ResourceBankShopManager';
import schoolManager from '../managers/SchoolManager';
import scoreCellGraderManager from '../managers/ScoreCellGraderManager';
import studentAssignmentManager from '../managers/StudentAssignmentManager';
import studentAssignmentPlayerLauncherManager from '../managers/StudentAssignmentPlayerLauncherManager';
import studentContentCardManager from '../managers/StudentContentCardManager';
import studentCourseDrivenExperienceManager from '../managers/StudentCourseDrivenExperienceManager';
import studentProgressManager from '../managers/StudentProgressManager';
import tagContentManager from '../managers/TagContentManager';
import teacherProductViewManager from '../managers/TeacherProductViewManager';
import thirdPartyManager from '../managers/ThirdPartyManager';
import topNavManager from '../managers/TopNavManager';
import userManager from '../managers/UserManager';
import verticalCourseTOCManager from '../managers/VerticalCourseTOCManager';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.AgentLinkHandlerView = SatCoreComponent('AgentLinkHandlerView');
    this.AssignmentDeepLinkHandlerView = SatCoreComponent('AssignmentDeepLinkHandlerView');
    this.AuthCallbackHandlerView = SatCoreComponent('AuthCallbackHandlerView');
    this.CertificateView = SatCoreComponent('CertificateView');
    this.ClassCourses = SatCoreComponent('ClassCourses');
    this.DemolinkLauncherView = SatCoreComponent('DemolinkLauncherView');
    this.DocReaderLaunch = SatCoreComponent('DocReaderLaunch');
    this.FileViewerLaunch = SatCoreComponent('FileViewerLaunch');
    this.ForgotPassword = SatCoreComponent('ForgotPassword');
    this.GoogleAnalyticsLauncher = SatCoreComponent('GoogleAnalyticsLauncher');
    this.LTIPlayerLauncher = SatCoreComponent('LTIPlayerLauncher');
    this.LearnosityPrintPreview = SatCoreComponent('LearnosityPrintPreview');
    this.LessonPortal = SatCoreComponent('LessonPortal');
    this.Login = SatCoreComponent('Login');
    this.LoginOneRoster = SatCoreComponent('LoginOneRoster');
    this.MainView = SatCoreComponent('MainView');
    this.NewPassword = SatCoreComponent('NewPassword');
    this.PlayerLaunch = SatCoreComponent('PlayerLaunch');
    this.PrivacyPolicy = SatCoreComponent('PrivacyPolicy');
    this.PublisherCourse = SatCoreComponent('PublisherCourse');
    this.Register = SatCoreComponent('Register');
    this.RegisterEcommerce = SatCoreComponent('RegisterEcommerce');
    this.RegisterInvite = SatCoreComponent('RegisterInvite');
    this.TermsOfUse = SatCoreComponent('TermsOfUse');
    this.TrialLauncherView = SatCoreComponent('TrialLauncherView');
    this.Verification = SatCoreComponent('Verification');
  }

  render() {
    const { GoogleAnalyticsLauncher } = this;

    return (
      <BrowserRouter>
        <RouterScrollToTop />
        <Provider
          accessManager={accessManager}
          accommodationsManager={accommodationsManager}
          adminClassroomManager={adminClassroomManager}
          adminUsersManager={adminUsersManager}
          appManager={appManager}
          assessmentManager={assessmentManager}
          assignmentManager={assignmentManager}
          bandwidthManager={bandwidthManager}
          basicIframeModalLauncherManager={basicIframeModalLauncherManager}
          classroomManager={classroomManager}
          classroomRosterManager={classroomRosterManager}
          contentItemManager={contentItemManager}
          contentManager={contentManager}
          contextHelpManager={contextHelpManager}
          courseDeliveryManager={courseDeliveryManager}
          courseManager={courseManager}
          courseResourceFilterManager={courseResourceFilterManager}
          curriculumMapManager={curriculumMapManager}
          dialogManager={dialogManager}
          docReaderManager={docReaderManager}
          dynamicSatelliteManager={dynamicSatelliteManager}
          engagementManager={engagementManager}
          exportManager={exportManager}
          filteredHeaderTableManager={filteredHeaderTableManager}
          googleAnalyticsManager={googleAnalyticsManager}
          googleClassroomManager={googleClassroomManager}
          gradebookManager={gradebookManager}
          groupsManager={groupsManager}
          guidedTourManager={guidedTourManager}
          itemBankManager={itemBankManager}
          learnosityAuthorManager={learnosityAuthorManager}
          learnosityDataManager={learnosityDataManager}
          learnosityItemsManager={learnosityItemsManager}
          libraryManager={libraryManager}
          loginManager={loginManager}
          ltiManager={ltiManager}
          navigationManager={navigationManager}
          notificationManager={notificationManager}
          productManager={productManager}
          reportContextManager={reportContextManager}
          reportCourseManager={reportCourseManager}
          reportIdentityManager={reportIdentityManager}
          reportOverrideManager={reportOverrideManager}
          reportScoreManager={reportScoreManager}
          reportStandardsClassroomDetailStudentsManager={reportStandardsClassroomDetailStudentsManager}
          reportStandardsManager={reportStandardsManager}
          reportTableManager={reportTableManager}
          reportTypeManager={reportTypeManager}
          reportUsageManager={reportUsageManager}
          resourceBankShopManager={resourceBankShopManager}
          schoolManager={schoolManager}
          scoreCellGraderManager={scoreCellGraderManager}
          studentAssignmentManager={studentAssignmentManager}
          studentAssignmentPlayerLauncherManager={studentAssignmentPlayerLauncherManager}
          studentContentCardManager={studentContentCardManager}
          studentCourseDrivenExperienceManager={studentCourseDrivenExperienceManager}
          studentProgressManager={studentProgressManager}
          tagContentManager={tagContentManager}
          teacherProductViewManager={teacherProductViewManager}
          thirdPartyManager={thirdPartyManager}
          topNavManager={topNavManager}
          userManager={userManager}
          verticalCourseTOCManager={verticalCourseTOCManager}>
          <GoogleAnalyticsLauncher />
          <LandscapeOrientationPrompt />
          <DynamicSatelliteLoadErrorModal />
          <Switch>
            <Route component={this.Login} path='/signin' />
            <Route component={this.LoginOneRoster} path='/loginOneRoster' />
            <Route component={this.Register} path='/register' />
            {/* TODO remove `/activate` route once KYA is ready to exclusively use shopify implementation (and our `/activation` route) */}
            <Route component={this.RegisterEcommerce} path='/activate' />
            <Route component={this.RegisterEcommerce} path='/activation' />
            <Route component={this.DemolinkLauncherView} path='/demolink/:demolinkId' />
            <Route component={this.RegisterInvite} path='/invitation/:id' />
            <Route component={this.ForgotPassword} path='/forgot-password' />
            <Route component={this.Verification} path='/verification' />
            <Route component={this.DocReaderLaunch} path='/docreader-launch' />
            <Route component={this.FileViewerLaunch} path='/fileviewer-launch' />
            <Route component={this.PlayerLaunch} path='/player-launch' />
            <Route component={this.PublisherCourse} path='/publisherCourse' />
            <Route component={this.NewPassword} path='/changePassword' />
            <Route component={this.LTIPlayerLauncher} path='/ltiPlayer' />
            <Route component={this.AssignmentDeepLinkHandlerView} path='/launch' />
            <Route component={this.AgentLinkHandlerView} path='/agentlink' />
            <Route component={this.AuthCallbackHandlerView} path='/authcallback' />
            <Route component={this.LessonPortal} path='/lesson-portal' />
            <Route component={this.LearnosityPrintPreview} path='/lrnPrint' />
            <Route component={this.CertificateView} path='/certificate' />
            <Route component={this.TrialLauncherView} path='/trial' />
            <Route component={this.TermsOfUse} path='/terms' />
            <Route component={this.PrivacyPolicy} path='/privacy' />
            <Route component={this.MainView} path='/' />
          </Switch>
        </Provider>
      </BrowserRouter>
    );
  }
}

SatCoreRegister('App', App);
